import { useEffect, useReducer, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { scrollToElement } from '../../../lib/userFunctions';
import FieldError from '../../common/FieldError';
import { useMutation, useQueryClient } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from 'utils/api/Api';
import { toast } from 'react-toastify';

const initialState = {
    id: null,
    page: null,
    type: 'GENERAL',
    title: '문의 드려요.',
    content: '',
    isSecret: "N",
    board: null
};

function qnaReducer(state, action) {
    return { ...state, ...action };
}

export const BoardQnaForm = ({ qna }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { school } = useParams();
    const queryClient = useQueryClient();

    const [state, setState] = useReducer(qnaReducer, initialState);
    const [errors, setErrors] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => scrollToElement(), []);

    useEffect(() => {
        if (qna === '') return;
        setState(qna);
    }, [qna]);

    const qnaStoreMutate = useMutation({
        mutationFn: (data) => Api.post('/api/board/qna/store', data),
        onSuccess: (res) => {
            queryClient.invalidateQueries({ queryKey: ['board/qna', String(res.data)] });
            queryClient.invalidateQueries({ queryKey: ['board/qna/list', { page: 0, user: 'N', school: '' }] });
            navigate(`/${school}/board/qna/view/${res.data}?${location.search}`);
        },
        onError: (err) => {
            const errorData = createFetchErrorMessage(err);
            setErrorMessage(errorData.message);
            setErrors(errorData.errors);
        }
    });

    // 
    const handleInput = (event) => {
        const target = event.target
        if (target.type === 'checkbox') {
            setState({ [target.name]: target.checked ? target.value : target.value === 'Y' ? 'N' : '' });
        } else {
            setState({ [target.name]: target.value });
        }

    }

    const onSave = () => {
        if (qnaStoreMutate.isPending) return;
        if (state.title.replaceAll(' ', '') === '') {
            toast.error('제목을 적어주세요.');
            return;
        }

        if (state.title.replaceAll(' ', '') === '') {
            toast.error('내용을 적어주세요.');
            return;
        }
        qnaStoreMutate.mutate(state);
    }

    return (
        <div className="section">
            <div className="inner">
                <div className="bbs_write">
                    <div className="title_area">
                        <h3>문의 및 요청 글쓰기</h3>
                    </div>
                    <div className="cont_area">
                        <div className="row">
                            <h4>제목</h4>
                            <FieldError name="title" errors={errors} >
                                <input type="text" name="title" value={state.title} onChange={handleInput} placeholder="제목을 입력하세요." />
                            </FieldError>
                        </div>
                        <div className="row">
                            <h4>내용</h4>
                            <FieldError name="content" errors={errors} >
                                <textarea name="content" value={state.content} onChange={handleInput} placeholder="내용을 입력하세요."></textarea>
                            </FieldError>
                        </div>
                        <div className="row">
                            <h4>비밀글</h4>
                            <div className="input_check">
                                <FieldError name="isSecret" errors={errors} >
                                    <input type="checkbox" value="Y" name="isSecret" id="privacyY"
                                        checked={state.isSecret === "Y"}
                                        onChange={handleInput} />
                                    <label htmlFor="privacyY">비밀글 사용</label>
                                </FieldError>
                            </div>
                        </div>
                    </div>
                </div>

                {errorMessage !== '' && <p className="errorMessage text-center">{errorMessage}</p>}

                <div className="bbs_btn alignC">
                    <button type="submit" className="btn _blue" onClick={onSave}>저장</button>
                    &nbsp;
                    <Link className="btn _border" to={`/${school}/board/qna?${location.search}`}>
                        목록
                    </Link>
                </div>
            </div>
        </div>
    );
}